import React from 'react';
import './Map3D.css';

const Map3D = () => {
  return (
    <div className="map-page">
      <h1>3D地图</h1>
      <div className="iframe-container">
        <iframe
          src="http://longtengrailway.top:18875"
          title="3D地图"
          width="100%"
          height="800px"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default Map3D;
